import styles from "../style/components/ArtistCityModals.module.scss";

type Props = {
    onSubmit: () => void;
    onClose: () => void;
};

const EmailUnsubModal: React.FC<Props> = ({ onSubmit, onClose }) => {

    return (
        <div className={styles["modal-overlay"]} onClick={onClose}>
            <div className={styles["modal"]} onClick={e => e.stopPropagation()}>
                <div className={styles["text-container"]}>
                    <div className={styles["thank-you-message"]}>
                        <h2 className={styles["title"]}>Unsubscribe?</h2>
                        <p>
                            Upon clicking unsubscribe, you will no longer receive weekly emails.
                            If you would like to re-subscribe to our weekly email digest, you can always
                            log in and visit your settings page
                        </p>
                    </div>
                </div>
                <div className={styles["buttons"]}>
                    <h6 onClick={onClose}>Home</h6>
                    <h6 className={styles["active"]} onClick={onSubmit}>Unsubscribe</h6>
                </div>
            </div>
        </div>
    );
};

export default EmailUnsubModal;
